
import React from 'react';
import {cls, Column, Grid, Row, Button} from '../../../packages/components';
import './styles/cardSerieSearch.scss';
import ProgressBar from '../../../components/ProgressBar';
import getBadges from '../../../utils/Badges';
import store from '../../../store';
import WrapperContentPlay from './WrapperContentPlay';
import SearchConstants from '../SearchConstants';
import Utils from '../../../utils/Utils';
import Translator from '../../../requests/apa/Translator';


const createMarkup =(markup) =>{
    return { __html: markup };
}

const cutString = (title) => {
    const cutTitle = Utils.cutPlayerString(title,25);
    return cutTitle;
};

const getNumberSeasons = (item) =>{
    let number = ''
    if(item && item.season_number){
        number =`${item.season_number} ${Translator.get('content_data_abbreviationSeason_label', 'Temp.')} | `;
    }
    return number;
}


const getLeftElement = (contentItem, percent = null, badges = null) => {
    return (
        <div className={cls(`aaf-main-search-card-serie-main`)}>
            <div
                className={cls('aaf-main-search-card-serie-main-container')}
                id={`modal_episode_number_${contentItem.idx_temp || null}`}
                data-id={contentItem.idx_temp || null}>
                <div className="aaf-main-search-card-serie-main-image">
                    <div
                        className={cls('aaf-main-search-card-serie-main-image-div')}
                        style={{
                            backgroundImage: 'url(' + contentItem.image_small + ')',
                            backgroundPosition: `center`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            'background-color': '#2d2d2d'
                        }}>
                        {percent && <div className={cls('aaf-main-search-card-serie-main-image-div-progress-bar','aaf-main-search-progress')}>
                            <div className={cls('aaf-main-search-card-serie-main-image-div-progress-children')}>
                                <ProgressBar percent ={percent}/>  
                            </div>
                        </div>}
                    </div>
                    {badges && <div className={`aaf-main-search-card-serie-main-badge-container`} dangerouslySetInnerHTML={createMarkup(badges)} />}
                </div>
            </div>
        </div>
    );
}

const getRightElement = (contentItem, changeRoute = null, getTextButtons = null) => {
    const tilte = (contentItem && contentItem.title) || ' ';
    const year = (contentItem && contentItem.year) || '';
    return ( 
        <Grid className={cls('aaf-main-search-card-serie-main-right')}>
            <Row className={cls('aaf-main-search-card-serie-main-right-row')}>
                <Column lg={12} className={cls('aaf-main-search-card-serie-main-right-column','aaf-main-search-card-serie-main-right-column-title')}>
                    {cutString(tilte)}
                </Column>
                <Column lg={12} className={cls('aaf-main-search-card-serie-main-right-column', 'aaf-main-search-card-serie-main-right-column-year')}>
                  {`${getNumberSeasons(contentItem)}${year}`}  
                </Column>
                <Column lg={12} className={cls('aaf-main-search-card-serie-main-right-column', 'aaf-main-search-card-serie-main-right-column_last')}>
                    <Button id={`${SearchConstants.FOCUSABLE_BUTTON}_${contentItem.idx_temp}`} className={cls(SearchConstants.FOCUSABLE, 'aaf-main-search-card-serie-main-right-button-more-info')} onClick={()=>{moreInfo(contentItem, changeRoute)}} dataOptions={{'data-id': contentItem.idx_temp, 'data-from-focusable': SearchConstants.FOCUSABLE_BUTTON}}>
                        {(typeof getTextButtons === 'function') && getTextButtons(SearchConstants.BUTTON_MORE_INFO)}
                    </Button>
                </Column>
            </Row>
        </Grid>
    );
}


const onClick = (element, isPlay = false, changeRoute, sentToPlaySerieVod) =>{
    
    const {id = null} = element;

    if(!isPlay){
        // Si el usuario selecciona el poster de un contenido VOD sin derecho en cualquier “parte” del mismo debe abrir la vcard.
        const {id = null} = element;
        (typeof changeRoute === 'function') && changeRoute(id);
    }else{
        id && sentToPlaySerieVod(id);
    }
}

const moreInfo = (element, changeRoute) =>{
    const {id = null} = element;
    (typeof changeRoute === 'function') && changeRoute(id);
} 





const CardSerieSearch = ({onFocus = null, item = {}, bookmark=[], changeRoute = null, user = null, getTextButtons = null, sentToPlaySerieVod = null, isPlay = false}) => {
    let badges = null;
    if(user){
        badges = getBadges(
        user,
        item.proveedor_code,
        item.format_types,
        item.live_enabled,
        item.id
      );
    }
    const {id= null} = item;
    let percent = false;
    const currentBookMark = bookmark.find((cu)=>cu.id === id);
    if(currentBookMark){
        const {vistime: {last : {progress = null} = {}} = {}} =  currentBookMark;
        percent = progress;
    }
    // width, isFakeCard = false, percent = null, onClick = null
    return (
        <WrapperContentPlay
            children_left = {
                getLeftElement(item, percent, badges)
            }
            children_right={
                getRightElement(item, changeRoute, getTextButtons)
            }
            onClick={() =>{onClick(item, isPlay, changeRoute, sentToPlaySerieVod)}}
            isPlay={isPlay}
            item ={item}
            onFocus = {onFocus}
        />
    );
};

export default CardSerieSearch;


// WEBPACK FOOTER //
// ./src/containers/Search/components/CardSerieSearch.jsx